import { Component } from '@angular/core';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css']
})
/** page-not-found component*/
export class PageNotFoundComponent {
    /** page-not-found ctor */
    constructor() {

    }
}